import { useThunkReducer } from 'react-hook-thunk-reducer';
import { useMemo } from 'react';
import reducer from './reducer';
import {
  UPDATE_ENTITY,
  INVALIDATE_ENTITY,
  CONNECTION_OFFLINE,
  CONNECTION_ONLINE,
  CREATE_ENTITY,
  EMPTY_CONTEXT,
  PARTIAL_CREATE_ENTITY,
  PARTIAL_UPDATE_ENTITY,
  INVALIDATE_ALL,
} from './types';
import { useRemoteDataThunk } from './thunks';
import { getKeyData } from './selectors';

const useRemoteData = () => {
  const [state, dispatch] = useThunkReducer(reducer, {});

  const useGetSync = (key, initialState) => {
    // try to get the value from the reducer
    const listData = getKeyData(state, { key, initialState });
    if (listData && listData.initialized) {
      return listData;
    }

    return {
      fetched: false,
      failed: false,
      initialized: false,
      loading: false,
      data: initialState,
    };
  };

  const operations = {
    useRemoteData: (...args) => dispatch(useRemoteDataThunk(...args)),
    updateEntity: (entity) => dispatch({ type: UPDATE_ENTITY, payload: { entity } }),
    createEntity: (entity, { keys } = { keys: [] }) => dispatch({ type: CREATE_ENTITY, payload: { entity, keys } }),
    partialCreateEntity: (entity, { keys } = { keys: [] }) =>
      dispatch({ type: PARTIAL_CREATE_ENTITY, payload: { entity, keys } }),
    partialUpdateEntity: (entity) => dispatch({ type: PARTIAL_UPDATE_ENTITY, payload: { entity } }),
    invalidateRemoteData: (key) => dispatch({ type: INVALIDATE_ENTITY, payload: { key } }),
    emptyData: () => dispatch({ type: EMPTY_CONTEXT }),
  };

  const global = {
    setOnline: () => dispatch({ type: CONNECTION_ONLINE }),
    setOffline: () => dispatch({ type: CONNECTION_OFFLINE }),
    invalidateAllRemoteData: () => {
      dispatch({ type: INVALIDATE_ALL });
    },
    emptyData: () => dispatch({ type: EMPTY_CONTEXT }),
  };

  const values = useMemo(() => Object.values(state), [state]);

  return [state, { operations, selectors: { useGetSync, getValues: () => values || [] }, global }];
};

export default useRemoteData;
